import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PackShot } from './PackShot';
import { images } from '../data/images';

/** Checkout de la tienda DPS-33 en ImpulTienda. */
const CHECKOUT_URL = 'https://softball-season-ready.impultienda.ar/checkout';
const included = ['6 complete volumes', '5 instant-use bonuses', '300 pages, print-ready', '43 ready-to-run practices', 'Three levels: 6U–8U, 10U–12U, HS & rec', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-215" data-mp="25s7w9a6ij01z">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-216" data-mp="20slhuxey7drl">
        <div className="text-center" data-id="element-217" data-mp="20vhg6mupk4gk">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-218" data-mp="3h6lfu2u8gtc7">
            Complete package
          </p>
          <h2 id="pricing-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-4xl sm:text-5xl" data-id="element-219" data-mp="3c7rz81jngm7t">
            Everything you need for the whole season
          </h2>
        </div>

        <div className="clip-corner mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-220" data-mp="9si8zz8jkj1o">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-221" data-mp="erldnikm0n94">
            <h3 className="font-display text-2xl uppercase tracking-wide text-white sm:text-3xl" data-id="element-222" data-mp="eoz8fpl6yju2">
              Softball Season-Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold" data-id="element-223" data-mp="3i8k182n9etsc">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-224" data-mp="3n5ag4mnbvjc6">
            {images.hero ? <img src={images.hero} alt="Softball Season-Ready complete package: all six volumes" width={1568} height={1041} loading="lazy" className="mx-auto w-full rounded-xl" data-id="element-225" data-mp="3rzes5kbgahk4" /> : <PackShot tone="light" data-id="element-226" data-mp="2rf1pporv8u0z" />}

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-227" data-mp="2mijrl7r1jtxm">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-228" data-mp="316xutjsddkep">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-green/15" data-id="element-229" data-mp="2w7uzir26ysjx">
                    <CheckIcon className="h-3 w-3 text-green" aria-hidden="true" data-id="element-230" data-mp="28j20glq9w4l3" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-231" data-mp="2idtxnofy0pfc">
              <p className="text-[13px] text-ink-soft" data-id="element-232" data-mp="2dfscmxyyig18">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-233" data-mp="3ttsck8xsy5oh">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-234" data-mp="3ovqqdf52xq8s">
                <span className="mt-2.5 font-display text-3xl" data-id="element-235" data-mp="a41llomekma">$</span>
                <span className="font-display text-7xl leading-[0.9] sm:text-8xl" data-id="element-236" data-mp="596zmm66nqkr">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-237" data-mp="3nfuznxmdlnjk">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-238" data-mp="3rirfjgkj75jt">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-239" data-mp="j26cegekz6om">
                  Save $63
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-240" data-mp="a7rzullfqa97">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-241" data-mp="11yxskgytt5og">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-242" data-mp="3f93bzokfozho">
                Get Softball Season-Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-243" data-mp="3592qbvz3e7ab">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-244" data-mp="3192e8hzgu86f">
                <li className="flex items-center gap-1.5" data-id="element-245" data-mp="1rucrobedtle">
                  <LockIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-246" data-mp="3sync0mmmrina" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-247" data-mp="3o6njhf8w3s0q">
                  <ZapIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-248" data-mp="3k74ykjh2jgxw" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-249" data-mp="kkoidrn4s9cy">
                  <ShieldCheckIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-250" data-mp="frvboy83qqy8" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-251" data-mp="23gc92cpkdl6q">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}